import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as config from '../backend.config';

const ADDRS_API1 = config.API;

// API description for all commnication with BACK-END for authentication
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS              Actions
//  POST	    api/auth/signin	  for User Login
//  POST      api/auth/signup   for User Registration
//  POST      api/auth/forget   User forgot password
//  POST      api/auth/reset    User change password

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  constructor(private http: HttpClient) { }

  login(data: any): Observable<any> {
    return this.http.post(ADDRS_API1 + `/accounts/login`, data);
  }

  unlock(data: any): Observable<any> {
    return this.http.post(ADDRS_API1 + `/accounts/unlock`, data);
  }

  // zarejestrowanie nowego użytkownika
  register(data: any): Observable<any> {
      return this.http.post(ADDRS_API1 + `/accounts/register`, data);
    }

  forget(data: any): Observable<any> {
    return this.http.post(ADDRS_API1 + `/accounts/forgot-password`, data);
  }

  reset(data: any): Observable<any> {
    return this.http.post(ADDRS_API1 + `/accounts/reset-password`, data);
  }
}
